import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './AddedPhotosCustomerOrder.module.scss';
import {resolveMediaUrl} from "../../configs/urls";
import {modalPreviewSelectedPhotoActions} from "../../store/slices/modalPreviewSelectedPhotoSlice";
import ModalPreviewSelectedPhoto from "../ModalPreviewSelectedPhoto/ModalPreviewSelectedPhoto";

const AddedPhotosCustomerOrder = ({photos}) => {
    const dispatch = useDispatch();
    const [photoForPreview, setPhotoForPreview] = useState(null);

    const {isPreviewOpen} = useSelector(state => state.modalPreviewSelectedPhoto);

    const handleSelectPhotoForPreview = (file) => {
        dispatch(modalPreviewSelectedPhotoActions.openPreview('AddedPhotosCustomerOrder'));

        setPhotoForPreview(file);
    };

    return (
        <div className={styles.addedPhotoCleanerOrder}>
            <p>Додані фото</p>

            <div className={styles.addedPhotoCleanerOrder_photos}>
                {photos?.map((file, index) =>
                    <div
                        className={styles.photo}
                        key={index}
                        style={{backgroundImage: `url(${resolveMediaUrl(file)})`}}
                        onClick={() => handleSelectPhotoForPreview(file)}
                    >
                    </div>
                )}
            </div>

            {isPreviewOpen &&
                <ModalPreviewSelectedPhoto
                    photo={resolveMediaUrl(photoForPreview)}
                    component={'AddedPhotosCustomerOrder'}
                />}
        </div>
    );
};

export default AddedPhotosCustomerOrder;
